import React from 'react'
import PropTypes from 'prop-types'
import Icon from 'components/common/Icon/Icon'
import { A } from 'components/common/Link/Link'
import Button from 'components/common/Button/Button'

const SharePageViaEmail = ({
  title,
  button,
  handleShowShareViaEmailModal,
  ...props
}) =>
  button ?
    <Button { ...props } onClick={ handleShowShareViaEmailModal } /> :
    <A { ...props } bolder prevent handler={ handleShowShareViaEmailModal } >
      <Icon asset="email-blue" margin="-2px 8px 0 0" />
      { title }
    </A>
export default SharePageViaEmail

SharePageViaEmail.propTypes = {
  button: PropTypes.bool,
  handleShowShareViaEmailModal: PropTypes.func,
  title: PropTypes.string
}
